module.exports = __webpack_public_path__ + "img/camera.7c6e1bc2.svg";